import { useState, useEffectEvent, useEffect } from "react";

import type { AgentSdk } from "../agentSdk";
import type { AgentActivity } from "../types";

import { sdkEventBus } from "../eventBus";

/** @returns true if the agent is in training mode, otherwise false */
export function useIsTrainingMode(isTrainingModeAllowed: boolean, sdk?: AgentSdk) {
    const [isTrainingMode, setIsTrainingMode] = useState(false);

    const onActivityChanged = useEffectEvent((activity: AgentActivity | undefined) => {
        setIsTrainingMode(isTrainingModeAllowed && (activity === "Training" || activity === "Residency"));
    });

    useEffect(() => {
        onActivityChanged(sdk?.getAgentActivity());

        return sdkEventBus.on("sdk_initialized", () => {
            onActivityChanged(sdk?.getAgentActivity());
        });
    }, [isTrainingModeAllowed, sdk]);

    useEffect(() => {
        return sdkEventBus.on("agent_activity_changed", ({ activity }) => {
            onActivityChanged(activity);
        });
    }, [isTrainingModeAllowed]);

    return isTrainingMode;
}
